<template>
    <div class="iframe-detail-container">
        <AIAHeaderText
            :headerText="headerText"
            :isShowShare="true"
            :isShowClose="true"
            :isShowBlack="false"
            @clickShare="clickShare"
            @clickClose="clickClose" />
        <div class="iframe-mask" v-if="isLoading">
            <div class="spinner"></div>
        </div>
        <iframe ref="iframe" frameborder="0" class="iframe-content"></iframe>
    </div>
</template>

<script>
import AIAHeaderText from "@/components/Layout/header/AIAHeaderText.vue";

export default {
    name: 'IframeDetail',
    components: {
        AIAHeaderText
    },
    props: {
        url: {
            type: String,
            required: true
        },
        headerText: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            isLoading: true
        };
    },
    mounted: function() {
        if (this.$refs.iframe) {
            this.$refs.iframe.addEventListener('load', this.iframeLoaded);
            this.$refs.iframe.src = this.url;
        }
    },
    beforeDestroy: function() {
        if (this.$refs.iframe) {
            this.$refs.iframe.removeEventListener('load', this.iframeLoaded);
        }
    },
    methods: {
        clickShare: function () {
            if (navigator.share) {
                var shareUrl = this.$refs.iframe ? this.$refs.iframe.src : this.url;
                navigator.share({
                    title: this.headerText || 'AIA Privilege',
                    url: shareUrl
                }).then(() => {
                    console.log('Thanks for sharing!');
                }).catch(console.error);
            } else {
                console.log('Web Share API not supported.');
            }
        },
        clickClose: function () {
            this.$emit('close');
        },
        iframeLoaded: function () {
            this.isLoading = false;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/style/base/base.scss';
.iframe-detail-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    background-color: #fff;
    z-index: 9999;
    display: flex;
    flex-direction: column;
}

.iframe-content {
    flex: 1;
    width: 100%;
    height: 100%;
    border: none;
}

.iframe-mask {
    position: absolute;
    top: 56px;
    left: 0;
    width: 100%;
    height: calc(100% - 56px);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $color-white;
    z-index: 10;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid $color-red;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
